import {Component, Input} from '@angular/core';
import {ThemeService} from '../../../services/theme.service';

@Component({
  selector: 'app-button',
  imports: [],
  templateUrl: './button.component.html',
  standalone: true,
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  constructor(protected themeService: ThemeService) {}

    @Input() height: number = 0;


    setHeight() {
      return this.height > 0 ? 'min-height:' + this.height + 'px;' : '';
    }
}
